import { render, staticRenderFns } from "./CalificacionCentralizadorLayout.vue?vue&type=template&id=6d5d4569&scoped=true"
import script from "./CalificacionCentralizadorLayout.vue?vue&type=script&lang=js"
export * from "./CalificacionCentralizadorLayout.vue?vue&type=script&lang=js"
import style0 from "./CalificacionCentralizadorLayout.vue?vue&type=style&index=0&id=6d5d4569&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d4569",
  null
  
)

export default component.exports